export default __webpack_public_path__ + "static/media/css06.61a35ecb.jpg";